import { render, staticRenderFns } from "./ProjectDesignOrderPopup.vue?vue&type=template&id=51678f5a"
import script from "./ProjectDesignOrderPopup.vue?vue&type=script&lang=ts"
export * from "./ProjectDesignOrderPopup.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDesignOrderPopup.vue?vue&type=style&index=0&id=51678f5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports